import React from 'react';
import { PageHero } from '../components/PageHero';
import { Button } from '../components/ui/Button';
import { navigate, BOOKING_URL } from '../lib/navigation';
import { Brain, Users, Video, BookOpen, ArrowRight, Receipt, DollarSign } from 'lucide-react';
export function Services() {
  return <div className="animate-fade-in-up" data-id="element-361">
      <PageHero title="Services" subtitle="Evidence-based support tailored to your unique journey." data-id="element-362" />

      <section className="py-20 bg-white" data-id="element-363">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-364">
          {/* Main Service: Individual Therapy */}
          <div className="bg-neutral-soft rounded-3xl p-8 md:p-12 mb-20 border border-sage/20 shadow-sm" data-id="element-365">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-366">
              <div data-id="element-367">
                <h2 className="text-3xl md:text-4xl font-medium text-teal mb-6" data-id="element-368">
                  Individual Therapy
                </h2>
                <p className="text-lg text-teal/80 mb-8 leading-relaxed" data-id="element-369">
                  One-on-one sessions where we dive deep into what's holding you
                  back. We'll use evidence-based approaches like CBT, DBT,
                  mindfulness, and narrative therapy to help you build a life
                  that feels authentic.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6" data-id="element-370">
                  <div className="flex items-center text-teal/80" data-id="element-371">
                    <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mr-4 shadow-sm text-terracotta" data-id="element-372">
                      <Video className="w-5 h-5" data-id="element-373" />
                    </div>
                    <div data-id="element-374">
                      <p className="font-semibold text-teal" data-id="element-375">Online</p>
                      <p className="text-sm" data-id="element-376">Across Ontario</p>
                    </div>
                  </div>
                  <div className="flex items-center text-teal/80" data-id="element-377">
                    <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mr-4 shadow-sm text-terracotta" data-id="element-378">
                      <Brain className="w-5 h-5" data-id="element-379" />
                    </div>
                    <div data-id="element-380">
                      <p className="font-semibold text-teal" data-id="element-381">50 Minutes</p>
                      <p className="text-sm" data-id="element-382">$130 per session</p>
                    </div>
                  </div>
                </div>

                {/* Insurance note */}
                <div className="flex items-start gap-3 p-4 bg-white rounded-xl border border-sage/15 mb-4" data-id="element-383">
                  <Receipt className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-384" />
                  <p className="text-sm text-teal/80" data-id="element-385">
                    <span className="font-medium text-teal" data-id="element-386">
                      Insurance accepted.
                    </span>{' '}
                    Receipts will be provided as needed for your insurance
                    provider.
                  </p>
                </div>

                {/* Sliding scale note */}
                <div className="flex items-start gap-3 p-4 bg-white rounded-xl border border-sage/15 mb-8" data-id="element-387">
                  <DollarSign className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-388" />
                  <p className="text-sm text-teal/80" data-id="element-389">
                    <span className="font-medium text-teal" data-id="element-390">
                      Sliding scale available.
                    </span>{' '}
                    I believe therapy should be accessible. If cost is a
                    barrier, let's talk about it.
                  </p>
                </div>

                <Button size="lg" onClick={() => window.open(BOOKING_URL, '_blank')} data-id="element-391">
                  Book Free Consultation
                </Button>
              </div>

              <div className="bg-white p-8 rounded-2xl border border-sage/10" data-id="element-392">
                <h3 className="text-xl font-medium text-teal mb-6" data-id="element-393">
                  Specialisations
                </h3>
                <ul className="space-y-4" data-id="element-394">
                  {['Anxiety and OCD', 'Life transitions (career, relationships)', 'Breaking people-pleasing patterns', 'Navigating comparison culture', 'Authentic confidence building', 'Stress and burnout'].map((item, i) => <li key={i} className="flex items-center text-teal/80 p-3 bg-neutral-soft rounded-lg" data-id="element-395">
                      <ArrowRight className="w-4 h-4 text-terracotta mr-3" data-id="element-396" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>

          {/* Coming Soon Section */}
          <div className="text-center mb-12" data-id="element-397">
            <h2 className="text-2xl font-medium text-teal mb-4" data-id="element-398">Coming Soon</h2>
            <p className="text-teal/70" data-id="element-399">
              Expanding our support options to meet you where you are.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-400">
            {[{
            title: 'Group Therapy',
            desc: 'Connect with others navigating similar challenges in a facilitated, safe space.',
            icon: <Users className="w-6 h-6" data-id="element-401" />
          }, {
            title: 'Workshops',
            desc: 'Focused sessions on specific topics like boundaries, anxiety, and self-compassion.',
            icon: <Brain className="w-6 h-6" data-id="element-402" />
          }, {
            title: 'Online Courses',
            desc: 'Self-paced learning to support your mental health journey from anywhere.',
            icon: <BookOpen className="w-6 h-6" data-id="element-403" />
          }].map((item, i) => <div key={i} className="bg-white border border-neutral-200 p-8 rounded-2xl opacity-70 hover:opacity-100 transition-opacity" data-id="element-404">
                <div className="w-12 h-12 bg-neutral-100 rounded-full flex items-center justify-center mb-6 text-teal" data-id="element-405">
                  {item.icon}
                </div>
                <h3 className="text-xl font-medium text-teal mb-3" data-id="element-406">
                  {item.title}
                </h3>
                <p className="text-teal/70 text-sm mb-4" data-id="element-407">{item.desc}</p>
                <span className="inline-block px-3 py-1 bg-neutral-100 text-teal/60 text-xs font-medium rounded-full" data-id="element-408">
                  Coming Soon
                </span>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}